import { render, staticRenderFns } from "./EventPrices.vue?vue&type=template&id=2f1a52a0&scoped=true"
import script from "./EventPrices.vue?vue&type=script&lang=js"
export * from "./EventPrices.vue?vue&type=script&lang=js"
import style0 from "./EventPrices.vue?vue&type=style&index=0&id=2f1a52a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a52a0",
  null
  
)

export default component.exports